import Button from '@components/atoms/button'
import { FastlyImage } from '@components/common/image'
import { useEffect, useState } from 'react'
import useResolution from '@hooks/useResolution'
import { WRAPPED_PDF_URL, wrappedYear } from '@pages/wrapped'

const FirstFold = () => {
  const {
    sizes: { sm },
  } = useResolution()
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div
      className="relative overflow-hidden"
      style={{
        height: 'calc(100vh - 64px)',
        background:
          'url("/images/wrapped/wrapped-first-fold-bg.svg"), linear-gradient(180deg, #FFBAB2 0%, #FFFFFF 100%)',
        backgroundRepeat: 'repeat-x',
      }}
    >
      <div
        className="absolute bottom-0 right-0 transition-transform duration-75 h-40 sm:h-auto"
        style={{
          transform: `translateY(${scrollY * 0.15}px)`,
        }}
      >
        <FastlyImage
          src="images/wrapped/penguin-iceberg.svg"
          width={283}
          height={190}
          alt="Iceberg"
        />
      </div>
      <div
        className="absolute top-5 sm:top-10 right-5 transition-transform duration-75"
        style={{
          transform: `translate(${scrollY * -0.1}px, ${
            scrollY * 0.2
          }px) translateY(-50%)`,
        }}
      >
        <FastlyImage
          src="images/wrapped/penguin-parachute.svg"
          width={98}
          height={108}
          alt="Parachute"
        />
      </div>
      <div
        className="absolute pt-4 sm:pt-0 top-5 pl-3 sm:pl-0 left-0 md:left-5 sm:left-10 transition-transform duration-75"
        style={{
          transform: `translate(${scrollY * 0.1}vw, ${scrollY * 0.05}vh)`,
        }}
      >
        <FastlyImage
          src="/images/wrapped/penguin-airplane.svg"
          width={65}
          height={59}
          alt="Airplane"
        />
      </div>
      <div className="flex flex-col items-stretch sm:items-center justify-center h-full max-w-5xl mx-auto gap-y-12 container px-5 md:px-12 relative">
        <h1 className="text-4xl sm:text-6xl md:text-8xl font-700 text-center">
          Codingal {wrappedYear} Wrapped is Here.
        </h1>
        <a href={WRAPPED_PDF_URL} target="_blank" rel="noopener noreferrer">
          <Button className="w-full sm:w-auto" size={sm ? 'lg' : 'xl'}>
            View Wrapped {wrappedYear}
          </Button>
        </a>
      </div>
    </div>
  )
}

export default FirstFold
